export const currency = (cost) => {
  return parseFloat(cost).toFixed(2);
}


export const currencyToDollars = (cost) => {
  return '$' + currency(cost);
}



// WEBPACK FOOTER //
// ./src/utils/currency.js